import React from "react";
import ReactDOM from "react-dom/client";
import { StyleSheetManager } from "styled-components";
import shouldForwardProp from "theme/shouldForwardProp";
import RecapWorker from "./workers/recapWorker?worker";
import { setRecapWorkerClass } from "@kubera/common";
setRecapWorkerClass(RecapWorker);
import * as Sentry from "@sentry/browser";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { GAWrapperInit } from "utilities/GAWrapper";
import { TrackVerifiedConnectionsInit } from "utilities/TrackVerifiedConnections";
import "array-flat-polyfill";
import structuredClone from "@ungap/structured-clone";
import isSupportedBrowser from "utilities/isSupportedBrowser";
import BrowserNotSupported from "./BrowserNotSupported";
import "utilities/loadProviderScript";
import { apiErrorCodes } from "@kubera/common";

const root = ReactDOM.createRoot(document.getElementById("root"));

const STALE_CHUNK_RELOAD_KEY = "stale_chunk_reload_at";
const STALE_CHUNK_RELOAD_COOLDOWN_MS = 10000;

window.addEventListener("vite:preloadError", () => {
  const lastReloadAt = Number(sessionStorage.getItem(STALE_CHUNK_RELOAD_KEY)) || 0;
  if (Date.now() - lastReloadAt < STALE_CHUNK_RELOAD_COOLDOWN_MS) {
    return;
  }

  sessionStorage.setItem(STALE_CHUNK_RELOAD_KEY, Date.now());
  window.isReloadingForStaleChunk = true;
  window.location.reload();
});

window.kbStructuredClone = value => {
  return !("structuredClone" in window) ? structuredClone(value) : window.structuredClone(value);
};

if (process.env.REACT_APP_ENV !== "local") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DNS,
    environment: process.env.REACT_APP_ENV,
    sendDefaultPii: true,
    ignoreErrors: [
      ...Object.keys(apiErrorCodes).map(key => `API_ERROR_${apiErrorCodes[key]}`),
      "WrappedError",
      "callback",
      "Non-Error exception captured with keys: errorCode, errorMessage, extra",
      "Event `CustomEvent` (type=unhandledrejection) captured as promise rejection",
      "Breaking change error",
      "Non-Error promise rejection captured with value: linkingProviderScriptLoadError",
      "Non-Error promise rejection captured with value: Timeout"
    ],
    denyUrls: [/^chrome-extension:\/\//i, /^moz-extension:\/\//i, /\/recaptcha\//i],
    beforeSend(event) {
      if (window.isSigningOut || window.isReloadingForStaleChunk) {
        return null;
      }
      return event;
    }
  });
}

GAWrapperInit();
TrackVerifiedConnectionsInit();

const withStyleSheetManager = children => (
  <StyleSheetManager shouldForwardProp={shouldForwardProp}>{children}</StyleSheetManager>
);

if (isSupportedBrowser()) {
  root.render(withStyleSheetManager(<App />));
} else {
  root.render(withStyleSheetManager(<BrowserNotSupported />));
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
serviceWorker.unregisterUnusedSW();
